export default "__VITE_ASSET__KYl5aWe9__"